package org.catharsis.spendtel.core.network

import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.catharsis.spendtel.core.network.SpendTelApiConfig.EXPENSE_REPORT_REQUEST_TIMEOUT_MS

actual fun createSpendTelHttpClient(): HttpClient = HttpClient(Js) {
    install(HttpTimeout) {
        requestTimeoutMillis = EXPENSE_REPORT_REQUEST_TIMEOUT_MS
        connectTimeoutMillis = 30_000
        socketTimeoutMillis = EXPENSE_REPORT_REQUEST_TIMEOUT_MS
    }
    install(ContentNegotiation) {
        json(
            Json {
                ignoreUnknownKeys = true
                encodeDefaults = true
                isLenient = true
            },
        )
    }
}
